const state = {
  dict: [],
  currentCity: {},
  session: '',
  userInfo: {},
}
const mutations = {
  SET_CITY: (state, data) => {
    state.currentCity = data
  },
  SET_DICT: (state, data) => {
    state.dict = data
  },
  REMOVE_DICT: (state, key) => {
    try {
      for (let i = 0; i < state.dict.length; i++) {
        if (state.dict[i].key == key) {
          state.dict.splice(i, i)
          return true
        }
      }
    } catch (e) {
    }
  },
  CLEAN_DICT: (state) => {
    state.dict = new Array()
  },
  SET_SESSION: (state, data) => {
    state.session = data
  },
  SET_USERINFO: (state, data) => {
    state.userInfo = data
  },
}

const actions = {
  // 设置字典
  setCity ({ commit }, data) {
    commit('SET_CITY', data)
  },
  // 设置字典
  setDict ({ commit }, data) {
    commit('SET_DICT', data)
  },
  // 删除字典
  removeDict ({ commit }, key) {
    commit('REMOVE_DICT', key)
  },
  // 清空字典
  cleanDict ({ commit }) {
    commit('CLEAN_DICT')
  },
  setToken ({ commit }, data) {
    commit('SET_SESSION', data)
  },
  setUserInfo ({ commit } , data) {
    commit('SET_USERINFO', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
